import React, { useState } from "react";
import "./ResearchPaperCarousel.css";

const ResearchPaperCarousel = ({ papers, theme }) => {
  const [index, setIndex] = useState(0);
  const total = papers.length;
  const paper = papers[index];

  const go = (delta) => setIndex((index + delta + total) % total);
  const pdfUrl = `${process.env.PUBLIC_URL}/papers/${paper.file}`;

  return (
    <div className="rp-carousel" style={{ color: theme.text }}>
      <div className="rp-stage">
        <button
          className="rp-arrow rp-arrow-left"
          onClick={() => go(-1)}
          aria-label="Previous paper"
          style={{ color: theme.text, borderColor: theme.text }}
        >
          ‹
        </button>

        <div className="rp-content">
          <div className="rp-embed-wrap">
            <object
              key={paper.file}
              data={`${pdfUrl}#view=FitH&toolbar=0`}
              type="application/pdf"
              className="rp-embed"
            >
              <div className="rp-embed-fallback">
                <p>PDF preview unavailable in this browser.</p>
                <a
                  href={pdfUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: theme.text, borderColor: theme.text }}
                  className="rp-fallback-link"
                >
                  Open {paper.title} ↗
                </a>
              </div>
            </object>
            <a
              href={pdfUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="rp-open-btn"
              style={{ background: theme.text, color: "#0E1A2B" }}
            >
              Open PDF ↗
            </a>
          </div>

          <div className="rp-info">
            <div className="rp-meta">
              <span className="rp-counter" style={{ opacity: 0.6 }}>
                {String(index + 1).padStart(2, "0")} / {String(total).padStart(2, "0")}
              </span>
              {paper.year && (
                <span className="rp-pill" style={{ borderColor: theme.text }}>
                  {paper.year}
                </span>
              )}
              {paper.status && (
                <span className="rp-pill rp-pill-status" style={{ borderColor: theme.text }}>
                  {paper.status}
                </span>
              )}
              {paper.highlight && (
                <span
                  className="rp-pill rp-pill-highlight"
                  style={{
                    borderColor: "#FFD700",
                    color: "#FFD700",
                    fontWeight: 600,
                  }}
                >
                  ★ Highlight
                </span>
              )}
            </div>
            <h3 className="rp-title">{paper.title}</h3>
            <p className="rp-desc">{paper.description}</p>
            {paper.tags && paper.tags.length > 0 && (
              <div className="rp-tags">
                {paper.tags.map((t) => (
                  <span key={t} className="rp-tag" style={{ borderColor: theme.text }}>
                    {t}
                  </span>
                ))}
              </div>
            )}
          </div>
        </div>

        <button
          className="rp-arrow rp-arrow-right"
          onClick={() => go(1)}
          aria-label="Next paper"
          style={{ color: theme.text, borderColor: theme.text }}
        >
          ›
        </button>
      </div>

      <div className="rp-dots">
        {papers.map((_, i) => (
          <button
            key={i}
            className={`rp-dot ${i === index ? "rp-dot-active" : ""}`}
            onClick={() => setIndex(i)}
            aria-label={`Go to paper ${i + 1}`}
            style={{
              background: i === index ? theme.text : "transparent",
              borderColor: theme.text,
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default ResearchPaperCarousel;
